<template>
	<div id="sendModal" class="modal" :style="visible ? 'block' : 'none'">
		<div class="modal-content">
			<span class="close" @click="$emit('trigger-modal')">&times;</span>
			<h3>Send Card</h3>
			<div class="send-form">
				<div v-if="request.success" class="success">
                  <h4>Card Sent!</h4>
				  Your card and message have been successfully sent.
				</div>

				<ValidationObserver ref="observer" v-slot="{ errors }" v-else>
					<form @submit="submit">
						<div class="col_2-1">
							<ValidationProvider v-slot="{ errors }" rules="required" name="first name">
								<input 
									:class="{'error-input': errors[0] }"
									type="text" 
									placeholder="First Name"
									v-model="form.first_name"
								/>
							</ValidationProvider>
						</div>

						<div class="col_2-2">
							<ValidationProvider v-slot="{ errors }" rules="required" name="last name">
								<input
									:class="{'error-input': errors[0] }"
									type="text" 
									placeholder="Last Name"
									v-model="form.last_name"
								/>
							</ValidationProvider>
						</div>

						<div class="clear" />

						<div class="col_2-1">
							<ValidationProvider v-slot="{ errors }" rules="email" name="email">
								<input 
									:class="{'error-input': errors[0] }"
									type="email" 
									placeholder="Email" 
									v-model="form.email"
								/>
							</ValidationProvider>
						</div>

						<div class="col_2-2">
							<ValidationProvider v-slot="{ errors }" rules="required|max:14|min:14" name="mobile number">
								<input
									:class="{'error-input': errors[0] }"
									type="tel"
									maxlength="15"
									placeholder="Mobile Number"
									v-model="form.phone"
									v-mask="'(###)-###-####'"
								/>
							</ValidationProvider>
						</div>

						<div class="clear"></div>
						
						<div class="col_1-1">
							<ValidationProvider v-slot="{ errors }" rules="required" name="message">
								<textarea
									:class="{'error-input': errors[0] }"
									:maxlength="maximumLength"
									placeholder="Message" 
									v-model="form.message"
								/>
							</ValidationProvider>
						</div>
						<div class="char-count">Characters Left: {{charactersLeft}}</div>
						<div class="clear"></div>
						<button class="send-btn">{{ request.pending ? 'Sending...' : 'Send'}}</button>
					</form>

					<div v-for="(property, key) in Object.keys(errors)" :key="property + key" class="error-list">
						<span v-for="(error, key) in errors[property]" :key="error + key">
							<b style="text-transform: capitalize">&bull; {{ property }}</b>: {{ error }}
						</span>
					</div>

					<div class="error-list" v-if="request.success === false">
						Some error occured. Please try again.
					</div>
				</ValidationObserver>
			</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */

	import axios from 'axios'

	import {
		ValidationProvider,
		ValidationObserver
	} from 'vee-validate/dist/vee-validate.full'

	import data from '../assets/data'

	export default {
		name: 'send',
		props: {
			visible: Boolean
		},
		components: { ValidationProvider, ValidationObserver },
		data() {
			return {
				maximumLength: 116,
				form: {
					first_name: '',
					last_name: '',
					email: '',
					phone: '',
					message: '',
					identifier_id: data.identifier_id
				},
				request: {
					pending: false,
					success: null,
				},
			}
		},
		computed: {
			charactersLeft: function() {
				return this.maximumLength - this.form.message.length
			}
		},
		methods: {
			// for test purposes only
			fakePost: function (time) {
				return new Promise((resolve, _) => {
					setTimeout(() => {
						resolve('Data fetched!')
					}, time)
				})
			},
			submit: async function (event) {
				const self = this

				event.preventDefault()

				// if (!await this.$refs.observer.validate()) return

				this.request.pending = true

				try {
					// fake promise for test purposes
					//await this.fakePost(3000)
					await axios.post('https://mbc-ts-api.lim.bz/api/lead', this.form)
					this.request.pending = false
					this.request.success = true
				} catch (error) {
					this.request.pending = false
					this.request.success = false
					console.log('[AXIOS ERROR]:', error.message || 'Axios exception thrown')
				}
            }
		},
		created() {
			this.request.success = null
		}
	}
</script>

<style scoped></style>
